import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setTourEdit } from "../../reducer/tourEditReducer";
import { Paths } from "../../router/Paths";
import RoleBasedComponent from "../../components/RoleBasedComponent";

export default function ManageHighlightsSection({ packageData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setTourEdit(packageData._id));
    navigate(Paths.tourManagementPackageDescription, {
      state: { packageData },
    });
  };
  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Highlights</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content  */}
      <div className="flex flex-col sm:items-end gap-6">
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <ul className="space-y-2 list-disc ml-4">
              {packageData?.highlights?.map(
                (highlight: string, index: number) => (
                  <li key={index} className="text-secondary capitalize">
                    {highlight}
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
